// @flow
import styled from "styled-components"
import { NavLink } from "componentsStyled/Typography"
import { mq, mqMax } from "common/mediaQuery"

export const LeftWrap = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`

export const RightWrap = styled.div`
  display: flex;
  align-items: center;
`

export const LogoWrap = styled.div`
  margin-right: 2rem;
`

export const ButtonsWrap = styled.div`
  margin-left: 2.5rem;

  & > button:first-child {
    margin-right: 1.6rem;
  }
`

export const StyledNavLink = styled(NavLink)`
  margin-left: 2.5rem;

  & + & {
    margin-left: 1rem;

    ${mq.tabletWide} {
      margin-left: 1rem;
    }
    ${mq.desktop} {
      margin-left: 1rem;
    }
    ${mqMax.tablet} {
      margin-left: 1rem;
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedOutNav/DesktopLoggedOutNav/styled.js